import { Dialog, type DialogProps } from '@mui/material';

export interface CustomDialogProps extends DialogProps {
  setDefaultWidth?: boolean;
}

export const CustomDialog: React.FC<CustomDialogProps> = ({
  children,
  maxWidth,
  setDefaultWidth = true,
  ...restProps
}) => {
  return (
    <Dialog
      maxWidth={maxWidth}
      PaperProps={{
        elevation: 0,
      }}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            ...(!maxWidth &&
              setDefaultWidth && {
                width: { xs: '95%', sm: '85%', md: '75%', lg: '65%' },
                maxWidth: 700,
              }),
            margin: 0,
          },
        },
      }}
      {...restProps}
    >
      <>{children}</>
    </Dialog>
  );
};
